<template>
  <b-form-group
    label="Başlangıç Tarihi"
    label-for="sdate"
  >
    <b-form-datepicker
      id="sdate"
      v-model="filterData.sdate"
      v-bind="{labelNoDateSelected: 'Tarih Seçiniz',labelHelp: 'Ok tuşlarıyla takvimde gezinin'}"
      locale="tr"
      start-weekday="1"
    />
  </b-form-group>
</template>

<script>
import {
  BFormGroup, BFormDatepicker,
} from 'bootstrap-vue'

export default {
  name: 'StartDate',
  components: {
    BFormGroup,
    BFormDatepicker,
  },
  computed: {
    filterData() {
      return this.$store.getters['interviews/filterData']
    },
  },
}
</script>
